import React, { useState, useEffect } from 'react';
import { InventoryPerMkt } from '../../../server/InventoryUpdate';
import { useSelector } from 'react-redux';
import { getLocations, updateInventoryLocation } from '../../../server/InventoryUpdate';


const ProductLocationPopUp = ({ product }) => {
 const { stationId, selectedProduct, items, stockType } = useSelector((state) => ({
   stationId: state.user.stationId,
   selectedProduct: state.selectedProduct.product,
   items: state.displayProduct.itemsShow,
   stockType: state.parameters.stock_type,
 }));


 const [location, setLocation] = useState([]);
 const [locations, setLocations] = useState(null);
 const [hasReturn, setHasReturn] = useState(false);
 const [selectedRow, setSelectedRow] = useState(null);
 const [newQuantity, setNewQuantity] = useState(1);
 const [whereHouse, setWhereHouse] = useState(false); 
 const [selectedWarehouse, setSelectedWarehouse] = useState(null);
 const [selectedWarehouseRow, setSelectedWarehouseRow] = useState(null);
 const [selectedCell, setSelectedCell] = useState(null);
 const [selectedCellStokeType, setSelectedCellStokeType] = useState(null);


 if (!product && selectedProduct) {
   product = selectedProduct;


   const matchingProduct = items.find((item) => item.Mkt === selectedProduct.Mkt);
   if (matchingProduct) {
     product = matchingProduct;
   }
 }


 useEffect(() => {
   getLocations(stationId, selectedCellStokeType ? selectedCellStokeType: null)
     .then((x) => {
       setLocations(x.data);
     })
     .catch(() => console.log('error'));
 }, [stationId, selectedCellStokeType]);


 useEffect(() => {
   InventoryPerMkt(product.Mkt, stationId)
     .then((x) => {
       setLocation(x.data);
       setHasReturn(true);
     })
     .catch(() => console.log('error'));
 }, [product.Mkt, stationId]);


 const handleRowClick = (row) => {
  console.log("row", row);
   setSelectedRow(row);
   setNewQuantity(row.Quantity);
   if (row.StokeTypeId !== selectedCellStokeType) {
     setSelectedCellStokeType(row.StokeTypeId);
   }
 };


 const addNewLocation = (dest) => {
   const updatedLocation = location.map((row) => {
     if (row.Id === selectedRow.Id) {
       return { ...row, Quantity: row.Quantity - newQuantity, QuantityCanCollect: row.QuantityCanCollect - newQuantity };
     }
     return row;
   });


   const data = {
     ...selectedRow,
     id: selectedRow.Id,
     mkt: selectedRow.ProductMkt,
     quantity: newQuantity,
     cellSrc: selectedRow.CellId,
     cellDest: whereHouse ? selectedCell.Id : locations[dest].Id,
     stationId: Number(stationId),
     stokeTypeId: selectedRow.StokeTypeId
   };


   console.log("dest", whereHouse, selectedCell)


   updateInventoryLocation(data)
   .then(() => {
     console.log('Location updated successfully');
     const updatedLocation = location.map((row) => {
       if (row.Id === selectedRow.Id) {
         return { ...row, Quantity: row.Quantity - newQuantity, QuantityCanCollect: row.QuantityCanCollect - newQuantity };
       }
       return row;
     });
     const newRow = {
       ...selectedRow,
       FullLocationName: dest,
       Quantity: newQuantity,
       QuantityCanCollect: newQuantity,
       Id: Date.now()
     };
     setLocation([...updatedLocation, newRow]);
   }).catch((error) => {
     console.error('Error updating location:', error);
   });


   setSelectedRow(null);
   closeWarehouseModal();
   setNewQuantity(1);
 }


 const handleWarehouseLocationClick = () => {
   if (!selectedRow || !selectedWarehouse || !selectedWarehouseRow || !selectedCell) return;
   const locationName = `${selectedCell.Name} - ${selectedWarehouseRow.Name} - ${selectedWarehouse.Name}`;
   addNewLocation(locationName);
 };


 const handleQuantityChange = (value) => {
   if (selectedRow) {
     const maxQuantity = selectedRow.Quantity;
     if (value >= 1 && value <= maxQuantity) {
       setNewQuantity(value);
     }
   }
 };


 const closeWarehouseModal = () => {
   setWhereHouse(false);
   setSelectedWarehouse(null);
   setSelectedWarehouseRow(null);
   setSelectedCell(null);
 };


 const warehouseData = locations?.מחסן || [];


 return (
 <>
   <div className='product-location'>
     <div className='product-header'>
       <h3>
         מלאי כללי: {product.Quantity}. מלאי למכירה: {product.QuantityCanOrder} :זמין להזמנות: מוזמן: מוקפא: פגומים:{' '}
       </h3>
     </div>
     <div className='table-location'>
       <table>
         <tbody>
           <tr>
             <th>מיקום</th>
             <th>כמות</th>
             <th>כמות זמינה</th>
             <th>תוקף</th>
             <th>מצב מלאי</th>
           </tr>
           {location.length ? (
             location.map((x) => (
               <tr
                 className={selectedRow?.Id === x.Id ? 'location-row active' : 'location-row'}
                 key={x.Id}
                 onClick={() => handleRowClick(x)}
               >
                 <td>{x.FullLocationName}</td>
                 <td>{x.Quantity}</td>
                 <td>{x.QuantityCanCollect}</td>
                 <td>{x.Expired ? new Date(x.Expired).toLocaleDateString('en-GB') : null}</td>
                 <td>{stockType.find((type) => type.Id === x.StokeTypeId)?.Name || 'לא נמצא'}</td>
               </tr>
             ))
           ) : hasReturn ? (
             <tr>
               <td>לא נמצאו מיקומים במלאי</td>
             </tr>
           ) : null}
         </tbody>
       </table>
     </div>
   </div>
 {selectedRow && (
   <div className='add-row'>
           <div className='quantity-input'>
             <button onClick={() => handleQuantityChange(newQuantity - 1)}>-</button>
             <input
               type='number'
               value={newQuantity}
               onChange={(e) => handleQuantityChange(parseInt(e.target.value))}
             />
             <button onClick={() => handleQuantityChange(newQuantity + 1)}>+</button>
             <button className="btn" onClick={() => addNewLocation('התאמות מלאי')}>התאמות מלאי</button>
             <button className="btn" onClick={() => addNewLocation('החזרות')}>החזרות</button>
             <button className="btn" onClick={() => addNewLocation('איבודים')}>איבודים</button>
             <button className="btn" onClick={() => addNewLocation('מחסן כניסה')}>מחסן כניסה</button>
             <button className="btn" onClick={() => setWhereHouse(true)}>מחסן</button>
         </div>
   </div>
   )}


   {whereHouse && (
     <div className="modal-overlay">
       <div className="modal-content">
         <button className="close" onClick={closeWarehouseModal}>×</button>
           <h3>בחירת מיקום</h3>   
           <h4>בחר טור:</h4>
           <div className='cell-selection'>
             {warehouseData.map((warehouse) => (
               <button
               className={'cell-button'}
                 key={warehouse.Id}
                 onClick={() => {
                   setSelectedWarehouse(warehouse);
                   setSelectedWarehouseRow(null);
                   setSelectedCell(null);
                 }}
                 style={{ backgroundColor: selectedWarehouse?.Id === warehouse.Id ? '#007cba' : 'white' }}
               >
                 {warehouse.Name}
               </button>
             ))}
           </div>


         {selectedWarehouse && (
           <>
             <h4>בחר שורה:</h4>
             <div className="cell-selection">
               {selectedWarehouse.Rows?.map((row) => (
                 <button
                   className='cell-button'
                   key={row.Id}
                   onClick={() => {
                     setSelectedWarehouseRow(row);
                     setSelectedCell(null);
                   }}
                   style={{ backgroundColor: selectedWarehouseRow?.Id === row.Id ? '#28a745' : 'white'}}>
                   {row.Name}
                 </button>
               ))}
             </div>
           </>
         )}


         {selectedWarehouseRow && selectedWarehouseRow.Cells && (
           <>
             <h4>בחר תא:</h4>
             <div className='cell-selection'>
               {selectedWarehouseRow.Cells.map((cell) => (
                 <button
                   className='cell-button'
                   style = {{ backgroundColor: selectedCell?.Id === cell.Id ? '#dc3545' : 'white'}}
                   key={cell.Id}
                   onClick={() => setSelectedCell(cell)}>
                   {cell.Name}
                 </button>
               ))}
             </div>
           </>
         )}


         <div className="modal-actions">
             <button
               className="cancel-btn"
               onClick={closeWarehouseModal}>
               ביטול
             </button>
             <button
             className={selectedWarehouse && selectedWarehouseRow && selectedCell ? 'submit-btn active' : 'submit-btn'}
               onClick={handleWarehouseLocationClick}
               disabled={!selectedWarehouse || !selectedWarehouseRow || !selectedCell}
             >
               אישור
             </button>
           </div>
         </div>
     </div>
   )}
 </>
 );
};

export default ProductLocationPopUp;